import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { ActualizarServicio } from './ActualizarServicio';
import { AvisoDePriviacidadWhats } from './AvisoDePriviacidadWhats';
import { InicioText } from './InicioText';
import { InputNumeroCelular } from './InputNumeroCelular';
import { ServicioActivo } from './ServicioActivo';
import { ServicioInactivo } from './ServicioInactivo';
import { ServicioNoActivo } from './ServicioNoActivo';

interface ContentModal {
    title: string;
    component: () => JSX.Element;
}

export const ModalContentWhats = () => {
    const {
        contentSelected,
        pinSent,
    } = useSelector((state: RootState) => state.servicioWhatsApp);

    const contentModal: { [key: string]: ContentModal } = {
        inicio: {
            title: "Nueva notificación via mensajería instantánea",
            component: () => <InicioText />,
        },
        noEstoyInteresado: {
            title: "¿Estás seguro de NO ACTIVAR la notificación via mensajería instantánea?",
            component: () => <ServicioNoActivo />,
        },
        avisoDePrivacidad: {
            title: "AVISO DE PRIVACIDAD PARA EL USO DEL SISTEMA DE NOTIFICACIÓN ELECTRÓNICA",
            component: () => <AvisoDePriviacidadWhats />,
        },
        confirmNumero: {
            title: pinSent ? "Confirma PIN" : "Número de celular",
            component: () => <InputNumeroCelular />,
        },
        successActive: {
            title: "¡Servicio activado correctamente!",
            component: () => <ServicioActivo />,
        },
        actualizarServicio: {
            title: "Servicio activado",
            component: () => <ActualizarServicio />,
        },
        cancelarServicio: {
            title: "¿Estás seguro de DESACTIVAR la notificación via mensajeria instantanea?",
            component: () => <ServicioNoActivo />,
        },
        successInactive: {
            title: "¡Servicio inactivado correctamente!",
            component: () => <ServicioInactivo />,
        },
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} margin={2} textAlign={"center"} justifyContent={'center'}>
                <Typography
                    variant="h5"
                >
                    {contentModal[contentSelected].title}
                </Typography>
            </Grid>
            <Grid item columns={12} my={1}>
                {
                    contentModal[contentSelected].component()
                }
            </Grid>
        </Grid>

    )
}
